<template>

    <template v-if="ValidateForm == null">
    <General 
        v-if="QuestionDynamic == false"
        v-for="(Question, index) in QuestionList" :key="index" 
        :ActiveQuestion="ActiveQuestion" 
        :FormularioTag="FormularioTag" 
        :tipo="Question.tipo" 
        :question="Question.question" 
        :response="Question.response" 
        :answers="Question.answers" 
        :help="Question.help" 
        :idQuestion="index"
        :indexAlgolia="Question.indexAlgolia"
        :AlgoliaApiKey="$store.state.AlgoliaApiKey" 
        :AlgoliaUser="$store.state.AlgoliaUser"
        :AlgoliaRefQuestion="Question.AlgoliaRefQuestion"
        :AlgoliaRefData="Question.AlgoliaRefData"
        :AlgoliaRefHelp="Question.AlgoliaRefHelp"
        :errorMsg="Question.errorMsg"
        :validate="Question.validate"
        :allresponses="Question.allresponses"
        :placeHolder="Question.placeholder"
        :minDate="Question.minDate"
        :maxDate="Question.maxDate"
        :loading="loading"
        :NumberQuestions="QuestionList.length"
        :PeriodoSeleccionado="$store.state.PeriodoSeleccionado"
        :PrecioProducto="$store.state.PrecioFinal"
        :PeriodosEscritos="$store.state.PeriodosEscritos"
        :productoAnterior="false"
        :PricingProducts="$store.state.Pricing.products"
        :ProductoSeleccionado="$store.state.ProductoSeleccionadoEnParrilla"
        :AddonsSeleccionados="$store.state.AddonsSeleccionados"
        :lopd="Question.lopd"
        :textoPantallaCarga="textoPantallaCarga"
        :Precios="$store.state.Precios"

        ></General>

     <General 
        v-if="QuestionDynamic == true"
        v-for="(Question, index) in QuestionList" :key="index" 
        :ActiveQuestion="ActiveQuestion" 
        :FormularioTag="FormularioTag" 
        :tipo="Question.tipo" 
        :question="QuestionTitle" 
        :response="Question.response" 
        :answers="Question.answers" 
        :help="Question.help" 
        :idQuestion="index"
        :indexAlgolia="Question.indexAlgolia"
        :AlgoliaApiKey="$store.state.AlgoliaApiKey" 
        :AlgoliaUser="$store.state.AlgoliaUser"
        :AlgoliaRefQuestion="Question.AlgoliaRefQuestion"
        :AlgoliaRefData="Question.AlgoliaRefData"
        :AlgoliaRefHelp="Question.AlgoliaRefHelp"
        :errorMsg="Question.errorMsg"
        :validate="Question.validate"
        :allresponses="Question.allresponses"
        :placeHolder="Question.placeholder"
        :minDate="Question.minDate"
        :maxDate="Question.maxDate"
        :loading="loading"
        :NumberQuestions="QuestionList.length"
        :PeriodoSeleccionado="$store.state.PeriodoSeleccionado"
        :PrecioProducto="$store.state.PrecioFinal"
        :PeriodosEscritos="$store.state.PeriodosEscritos"
        :productoAnterior="false"
        :PricingProducts="$store.state.Pricing.products"
        :ProductoSeleccionado="$store.state.ProductoSeleccionadoEnParrilla"
        :AddonsSeleccionados="$store.state.AddonsSeleccionados"
        :lopd="Question.lopd"
        :textoPantallaCarga="textoPantallaCarga"
        :Precios="$store.state.Precios"

        ></General>
    </template>
    <template v-else>
    <!-- Features -->
    <div class="bg-soft-warning">
        <div class="container content-space-1">

            <div class="w-lg-65 text-center mx-lg-auto mb-7" style="padding-bottom:200px;" v-if="ValidateForm == true">
            
                <h2>Muchas gracias por elegirnos</h2> 

                <p :v-html="DataFinal.validMsg"></p>

                <p>
                    Le recordamos que puede <b>ponerse en contacto con nosotros de lunes a viernes de (9:00 a 19:00)</b> en el <b>teléfono {{company_telefono}}</b>, 
                    o a través del correo electrónico <b>{{company_email}}</b>.
                </p>
            
            </div>
            <div class="w-lg-65 text-center mx-lg-auto mb-7" style="padding-bottom:200px;" v-if="ValidateForm == false">
            
                <h2>Error en el Formulario</h2> 

                <p :v-html="DataFinal.errorMsg"></p>

                <p>

                    Por favor pongase en contacto con nosotros en el número de teléfono <b>{{company_telefono}}</b>, o en el email <b>{{company_email}}</b>.

                </p>

            
            
            </div>

        </div>
    </div>


    
    </template>


    <Personalizado
    :Preguntas="QuestionList"
    :Formulario="FormularioTag"
    
    ></Personalizado>



     
</template>

<script>

import General from './General.vue'
import Dinamico from './DynamicTitle/TituloDinamico.js'
import Personalizado from './Personalizado.vue'

export default {
    name: 'CreateForm',
    components : { General, Personalizado },
    props : {

        QuestionList : Array,
        FormularioTag : String,
        ActiveQuestion: Number,
        ValidateForm: Boolean,
        DataFinal : Object,
        loading: Boolean,
        textoPantallaCarga: String

    },
    data: function(){

        return {

            QuestionDynamic: false,
            QuestionTitle: null,
            company_email: null,
            company_telefono: null

        }


    },

    mounted: async function(){


        if (company_email)
        {

            this.company_email = company_email;
  
        }


        if (company_telefono){

            this.company_telefono = company_telefono;


        }


        if (ajaxUrl){

            this.$store.commit('CambiarAjax', ajaxUrl);

        }

        if (urlIntegromat){

            this.$store.commit('CambiarIntegromat', urlIntegromat);

        }


        window.scrollTo(0, 0);

        this.$watch('ActiveQuestion', function () {
            
            let PreguntaActual = this.QuestionList[this.ActiveQuestion];

            let esDinamico = Dinamico.EsTituloDinamico(PreguntaActual.question, this.QuestionList);

            this.QuestionDynamic = esDinamico.status;
            this.QuestionTitle = esDinamico.data;


        });



    }

}
</script>